import { GlobalService } from 'src/app/global.service';
import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { ThemePalette, ProgressSpinnerMode, MatDialog } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { T } from '@angular/cdk/keycodes';

@Component({
  selector: 'app-daily-sale-upload',
  templateUrl: './daily-sale-upload.component.html',
  styleUrls: ['./daily-sale-upload.component.scss']
})
export class DailySaleUploadComponent implements OnInit {
  sessions: any;
  selected_date: any;
  selected_session_id: any;
  is_document_available: boolean = true;
  document_file: any = null;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  pdf_data: any;
  title: any;
  grn_excel_file = null;
  product_excel_file = null;

  constructor(private httpService: HttpService, private global: GlobalService) {
    this.title = this.global._active_display_name;
  }

  convertExcelToBase64ForGrn(event) {
    console.log(event);
    console.log('to base 64');
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file)
    reader.onloadend = (e) => {
      console.log(reader.result);
      this.grn_excel_file = reader.result
    };
    console.log(this.grn_excel_file);
  }

  convertExcelToBase64ForProduct(event) {
    console.log(event);
    console.log('to base 64');
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file)
    reader.onloadend = (e) => {
      console.log(reader.result);
      this.product_excel_file = reader.result
    };
    console.log(this.product_excel_file);
  }

  changeEvent() {
    this.grn_excel_file = null;
    this.product_excel_file = null;
  }

  uploadClicked() {
    console.log('enters');
    let data_dict = {
      'selected_date': this.selected_date,
      'grn_excel_file': this.grn_excel_file,
      'product_excel_file': this.product_excel_file
    }
    console.log(data_dict);
    this.is_document_available = false;
    this.httpService.dailySaleUpload(data_dict).subscribe((data) => {
      console.log(data);
      this.is_document_available = true;
      if (data['is_everything_okay']) {
        alert('Uploaded successfully');
        window.location.reload();
      } else {
        if (data['error_on'] == 'product') {
          if (data['is_limit_crossed']) {
            alert(data['product_name'] + 'available' + data['available_qty'])
          } else {
            alert(data['error'])
          }
        } else {
          alert(data['error'])
        }
      }
    }, (error) => {
      console.error(error);
      alert('Error while uploading');
      console.log(data_dict);
      this.is_document_available = true;
    });
  }

  deleteClicked() {
    if (confirm('Are you sure want to delete')) {
      this.is_document_available = false;
      this.httpService.deleteOverallSale().subscribe((data) => {
        console.log(data);
        alert('Deleted successfully');
        this.is_document_available = true;
      }, (error) => {
        this.is_document_available = true;
      });
    }
  }

  ngOnInit() {
  }

}
